import axios from "../utils/index";
import { encryptWithPublicKey } from "../utils/rsaEncrypt";

const api = {
  async signIn(data: any, callback: (T: any) => void) {
    try {
      const encrypted = encryptWithPublicKey(data.key, data.password);
      axios
        .post(`/v1/portal/portal-login`, {
          email: data.email,
          password: encrypted,
        })
        .then((res) => {
          callback(res.data);
        })
        .catch((err) => {
          callback(err);
        });
    } catch (err: any) {
      callback({ code: 500, message: err?.message || "Unable to encrypt password" });
    }
  },
  forgotPasswordApi({ params = {} as any, callback = (() => {}) as any }) {
    axios
      .post(`/v1/hospital/hospital-forgotPassword-getSessionId`, params)
      .then((res) => {
        callback(res);
      })
      .catch((err) => {
        callback(err);
      });
  },
  signOut({ callback = (() => {}) as any }) {
    axios
      .post(`/v1/portal/portal-logout`)
      .then((res) => {
        callback(res);
      })
      .catch((err) => {
        callback(err);
      });
  },
  getKey({ callback = (() => {}) as any }) {
    axios
      .get(`/v1/public/rsa/get-publicKey`)
      .then((res) => {
        callback(res);
      })
      .catch((err) => {
        callback(err);
      });
  },
  registerApi({ params = {} as any, callback = (() => {}) as any }) {
    axios
      .post(`/v1/portal/leads-add`, params)
      .then((res) => {
        callback(res);
      })
      .catch((err) => {
        callback(err);
      });
  },
  editPsdApi({ params = {} as any, callback = (() => {}) as any }) {
    try {
      const encrypted = encryptWithPublicKey(params.key, params.password);
      axios
        .put(`/v1/hospital/account/account-password-edit`, {
          password: encrypted,
        })
        .then((res) => {
          callback(res);
        })
        .catch((err) => {
          callback(err);
        });
    } catch (err: any) {
      callback({
        data: { code: 500, message: err?.message || "Unable to encrypt password" },
      });
    }
  },
  checkLinkAvailable({ params = {} as any, callback = (() => {}) as any }) {
    axios
      .get(`/v1/hospital/hospital-forgotPassword-check-code/${params.code}`)
      .then((res) => {
        callback(res);
      })
      .catch((err) => {
        callback(err);
      });
  },
  resetPasswordApi({ params = {} as any, callback = (() => {}) as any }) {
    try {
      const encrypted = encryptWithPublicKey(params.key, params.data.password);
      axios
        .post(`/v1/hospital/hospital-password-reset`, {
          code: params.data.code,
          password: encrypted,
        })
        .then((res) => {
          callback(res);
        })
        .catch((err) => {
          callback(err);
        });
    } catch (err: any) {
      callback({
        data: { code: 500, message: err?.message || "Unable to encrypt password" },
      });
    }
  },
};

export default api;
